import { createSlice } from '@reduxjs/toolkit';
import { handleGetListProvinces, handleGetSensorTypes } from './masterThunk';
import { IMasterData } from '~/utils/interface/master';

const initialState: IMasterData = {
  provinces: [],
  sensorTypes: [],
};

const masterSlice = createSlice({
  name: 'master',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(handleGetListProvinces.fulfilled, (state, action) => {
        state.provinces = action.payload;
      })
      .addCase(handleGetSensorTypes.fulfilled, (state, action) => {
        state.sensorTypes = action.payload;
      });
  },
});

export const masterActions = masterSlice.actions;

const masterReducer = masterSlice.reducer;
export default masterReducer;
